export default {"src":"/_next/static/media/icon-2-step-auth2.2fc1eb40.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};